// socketModule.js

const socketModule = {
    connectedSocket: null,
    connectWebSocket: function (callback) {
        const socket = new WebSocket('wss://ws1.goya-alert.com/exc');

        socket.onopen = function () {
            // // console.log("WebSocket 연결이 열렸습니다.");
            socket.send(JSON.stringify({
                "exchange": "all",
                "type": "symbols"
            }));
        };

        socket.onerror = function (error) {
            console.error("WebSocket 에러:", error);
        };

        socket.onmessage = function (event) {
            if (event.isTrusted == true) {
                const symbolList = JSON.parse(event.data);
                callback(symbolList); // 콜백 함수를 호출하여 데이터 전달
            }
        };
    },
    connectPriceSocket: function (data, callback) {

        if (this.connectedSocket && this.connectedSocket.readyState != 0) {
            this.connectedSocket.close();
            this.connectedSocket = null;
            // console.log('이전 연결 해제');
        }

        this.connectedSocket = new WebSocket('wss://ws1.goya-alert.com/volume');

        this.connectedSocket.onopen = function () {
            // console.log("price 웹소켓 연결이 열렸습니다.");
            // console.log('data', data);
            // console.log('this',this);
            this.send(JSON.stringify([data]));
        };

        this.connectedSocket.onerror = function (error) {
            console.error("WebSocket 에러:", error);
        };

        this.connectedSocket.onmessage = function (event) {
            // if (event.isTrusted == true) {
            const currentPrice = JSON.parse(event.data);
            callback(currentPrice); // 콜백 함수를 호출하여 데이터 전달
            // }
        };
        // this.connectedSocket.onclose = function(event) {
        //     // console.log('웹소켓 연결이 종료되었습니다.', event);
        //     this.connectedSocket = null
        // };
    },
    disconnectSocket: function () {
        // if (this.connectedSocket) {
        //     // console.log('현재 소켓 상태:', this.connectedSocket.readyState);
        //     switch (this.connectedSocket.readyState) {
        //         case WebSocket.CONNECTING:
        //             // console.log('소켓이 연결 중입니다. 연결을 종료합니다.');
        //             this.connectedSocket.close(); // 강제로 연결 종료 시도
        //             break;
        //         case WebSocket.OPEN:
        //             // console.log('소켓이 열려 있습니다. 연결을 종료합니다.');
        //             this.connectedSocket.close();
        //             break;
        //         case WebSocket.CLOSING:
        //             // console.log('소켓이 이미 닫히는 중입니다.');
        //             break;
        //         case WebSocket.CLOSED:
        //             // console.log('소켓이 이미 닫혔습니다.');
        //             break;
        //         default:
        //             // console.log('알 수 없는 상태:', this.connectedSocket.readyState);
        //     }
        // } else {
        //     // console.log('소켓 연결이 존재하지 않습니다.');
        // }
        // // console.log('현재 소켓 상태:', this.connectedSocket.readyState);
        if(this.connectedSocket !=null && this.connectedSocket.readyState != 0){
            this.connectedSocket.close()
            this.connectedSocket = null
            // console.log('연결종료');
            // this.connectedSocket.onclose = function(event) {
            // // console.log('웹소켓 연결이 종료되었습니다.', this.connectedSocket.readyState);
                // this.connectedSocket = null
            // };
        }
    }
};

export default socketModule;
